<app-date-controls (dateChange)="onChangedDate($event)"></app-date-controls>
<app-image-columns [data]="data" [column]="1" [restPolicy]="'full'"></app-image-columns>